<template>
  <div>
    <HeaderKuesioner />
    <section class="kuesioner-page">
      <div class="container">
        <div class="page-header">
          <h2>Pilih Kuesioner</h2>
          <p>Silakan pilih jenis kuesioner yang sesuai dengan jenjang pendidikan Anda.</p>
        </div>

        <div v-if="loading" class="text-center py-5">
          <Loading />
        </div>

        <div v-else class="survey-grid">
          <div
            v-for="(survey, index) in surveys"
            :key="survey.id"
            class="survey-card"
            :class="{ 'survey-card-atasan': survey.survey_category_id === 4 }"
            @click="direct(survey)"
          >
            <div class="survey-card-number">
              {{ index + 1 }}
            </div>
            <div class="survey-card-content">
              <span class="survey-category">{{ survey.survey_category }}</span>
              <h3>{{ survey.name }}</h3>
              <p class="survey-desc" v-if="survey.survey_category_id !== 4">Klik untuk mulai mengisi kuesioner ini</p>
              <p class="survey-desc survey-atasan-note" v-else><i class="bx bxs-info-circle"></i> Khusus untuk atasan/pengguna lulusan, bukan alumni</p>
            </div>
            <div class="survey-card-arrow">
              <i class="bx bx-right-arrow-alt"></i>
            </div>
          </div>
        </div>

        <div v-if="!loading && (!surveys || surveys.length === 0)" class="empty-state">
          <i class="bx bx-file-blank"></i>
          <p>Belum ada kuesioner yang tersedia saat ini.</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderKuesioner from "@/components/hero/HeaderKuesioner.vue";
import Loading from "@/components/Loading.vue";
import SurveyService from "@/services/survey.service";

export default {
  name: "Kuesioner",
  components: {
    HeaderKuesioner,
    Loading,
  },
  data() {
    return {
      loading: false,
      surveys: [],
    };
  },
  mounted() {
    this.loading = true;
    this.$store.commit("SHOW_LOADING", "Memuat kuesioner...");
    SurveyService.getListSurveysUser()
      .then(function (res) {
        this.surveys = res.data.surveys || [];
        this.loading = false;
        this.$store.commit("HIDE_LOADING");
      }.bind(this))
      .catch(function (error) {
        console.error(error);
        this.loading = false;
        this.$store.commit("HIDE_LOADING");
      }.bind(this));
  },
  methods: {
    direct(row) {
      // Routing kuesioner per survey_category_id (mapping survey_categories di DB):
      //   1 = Diploma dan Sarjana                  → verifikasi (D3/S1 form)
      //   2 = Pascasarjana dan Profesi             → verifikasi-pasca
      //   3 = Kuesioner Profesi Keinsinyuran       → verifikasi-pasca (same form)
      //   4 = User Survey (Atasan/DUDI)            → verifikasi-dudi
      //   6 = Diploma dan Sarjana (bekerja)        → verifikasi (sub-flow sudah bekerja)
      //   7 = Diploma dan Sarjana (belum bekerja)  → verifikasi (sub-flow belum bekerja)
      var cat = parseInt(row.survey_category_id, 10);
      var route;
      if (cat === 4) {
        route = "verifikasi-dudi";
      } else if (cat === 2 || cat === 3) {
        route = "verifikasi-pasca";
      } else {
        // cat 1, 6, 7, atau fallback default
        route = "verifikasi";
      }
      this.$router.push({ name: route, params: { id: row.id } });
    },
  },
};
</script>

<style scoped>
.kuesioner-page {
  background: #f5f7f6;
  min-height: 60vh;
  padding: 40px 0 80px;
  font-family: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, sans-serif;
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.page-header h2 {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 8px;
}

.page-header p {
  font-size: 0.95rem;
  color: #666;
  margin: 0;
}

.survey-grid {
  max-width: 700px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.survey-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  border: 2px solid transparent;
  transition: all 0.2s;
}

.survey-card:hover {
  border-color: #003E29;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0,62,41,0.1);
}

.survey-card-number {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #003E29, #00664a);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 700;
  flex-shrink: 0;
}

.survey-card-content {
  flex: 1;
}

.survey-category {
  font-size: 0.75rem;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.survey-card-content h3 {
  font-size: 1.05rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 4px 0 6px;
}

.survey-desc {
  font-size: 0.8rem;
  color: #999;
  margin: 0;
}

.survey-card-arrow {
  font-size: 24px;
  color: #ccc;
  transition: color 0.2s;
}

.survey-card:hover .survey-card-arrow {
  color: #003E29;
}

.survey-card-atasan {
  border: 2px dashed #e5e7eb;
  background: #fafafa;
}

.survey-card-atasan:hover {
  border-color: #e65100;
  border-style: solid;
}

.survey-atasan-note {
  color: #e65100 !important;
  display: flex;
  align-items: center;
  gap: 4px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #888;
}

.empty-state i {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
}

@media (max-width: 576px) {
  .survey-card {
    padding: 18px;
    gap: 14px;
  }

  .survey-card-number {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
}
</style>
